/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Sour_Tadpole_RushInputs */

const fr_close_sour_tadpole_rush = /** @type {(inputs: Close_Sour_Tadpole_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière notification`)
};

/**

* @param {Close_Sour_Tadpole_RushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const close_sour_tadpole_rush = /** @type {((inputs?: Close_Sour_Tadpole_RushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Sour_Tadpole_RushInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_close_sour_tadpole_rush(inputs)
});